import { IconCheck, IconPlus } from "@tabler/icons-react";
import { Image } from "../../../../components/common/image";
import { Button } from "../../../../components/common/button";
import { Text } from "../../../../components/common/typography";
import { GatedPrice } from "../../../../components/common/gated-price";
import type { ProductDto } from "../../../../api";

interface Props {
  product: ProductDto;
  alreadyFeatured: boolean;
  busy: boolean;
  onAdd: (product: ProductDto) => void;
}

export function AdminDealSearchRow({ product, alreadyFeatured, busy, onAdd }: Props) {
  const title = product.displayName ?? product.name ?? "—";
  const brand = product.brand?.name;
  const category = product.category?.name;
  const price = product.listPrice ?? 0;

  return (
    <article className="flex items-center gap-4 rounded-2xl border border-borderDefault bg-bgWhite p-4 shadow-[0px_2px_6px_0px_rgba(190,189,217,0.2)] transition-colors hover:border-borderDark">
      <div className="h-16 w-16 shrink-0 overflow-hidden rounded-lg bg-bgLight">
        <Image
          image={product.image}
          alt={title}
          size="w-full h-full"
          objectFit="contain"
          showPlaceholder
        />
      </div>

      <div className="flex min-w-0 flex-1 flex-col gap-0.5">
        <Text variant="bodyBold" tone="dark" className="line-clamp-1">
          {title}
        </Text>
        <div className="flex flex-wrap items-center gap-x-3 gap-y-0.5">
          {brand && (
            <Text variant="bodyXs" tone="muted" className="line-clamp-1">
              {brand}
            </Text>
          )}
          {category && (
            <Text variant="bodyXs" tone="muted" className="line-clamp-1">
              {category}
            </Text>
          )}
          {product.defaultCode && (
            <Text variant="bodyXs" tone="muted" className="line-clamp-1">
              SKU {product.defaultCode}
            </Text>
          )}
        </div>
      </div>

      <div className="hidden shrink-0 sm:block">
        <Text variant="bodyBold" tone="dark">
          <GatedPrice>QAR {price.toLocaleString()}</GatedPrice>
        </Text>
      </div>

      <Button
        variant={alreadyFeatured ? "secondary" : "primary"}
        size="sm"
        leftIcon={alreadyFeatured ? <IconCheck size={16} /> : <IconPlus size={16} />}
        disabled={alreadyFeatured || busy}
        onClick={() => onAdd(product)}
      >
        {alreadyFeatured ? "Added" : "Add"}
      </Button>
    </article>
  );
}
